import { render, staticRenderFns } from "./HeaderMenu.vue?vue&type=template&id=7d78af9c"
import script from "./HeaderMenu.vue?vue&type=script&lang=js"
export * from "./HeaderMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d78af9c')) {
      api.createRecord('7d78af9c', component.options)
    } else {
      api.reload('7d78af9c', component.options)
    }
    module.hot.accept("./HeaderMenu.vue?vue&type=template&id=7d78af9c", function () {
      api.rerender('7d78af9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/header/type_7/HeaderMenu.vue"
export default component.exports